import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

export const Card = styled.div`
  display: block;
  min-height: 100%;
  min-width: 146px;
  flex: 1 0 146px;
  overflow-wrap: break-word;
  text-align: center;
  padding-bottom: 1rem;

  ${media.mediumUp`
    min-width: 200px;
    flex-basis: 200px;
  `};
`;

export const ImageAndDate = styled.div`
  position: relative;

  img {
    padding: 10px 0;
  }

  div {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  span {
    color: white;
    background: #fdbb01;
    border-radius: 3px;
    border: 2px solid white;
    padding: 0 3px;
    margin-bottom: 15px;
    display: inline-block;
  }
`;

export const ExpectedPrice = styled.div`
  color: #939393;
  text-align: left;
`;

export const ProductName = styled.div`
  margin-top: 5px;
  margin-right: 5px;
  height: ${layout.lineHeight * 2}em;
  line-height: ${layout.lineHeight}em;
  overflow: hidden;
  text-align: left;
`;

// #002239
